module.exports = __webpack_public_path__ + "media/images/redesign-images/higher-ed/event-03-abc5888d91ceb7abf0053122d8a20bd0.jpg";